import {XCircle} from 'lucide-react'
import { motion } from "framer-motion"

const painPoints = [
  "Tempo no trânsito para chegar à escola",
  "Horário da escola atrapalhando sua rotina",
  "Escola tradicional focada só em gramática",
  "App de frases prontas que você repete sem entender",
  "Curso que promete fluência milagrosa",
  "Nenhum contato com professor real",
]

function PainSection() {
  return (
    <section className="bg-gray-100 py-14 sm:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10"
        >
          Você já tentou aprender inglês assim:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {painPoints.map((point, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm"
            >
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 font-medium">{point}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center space-y-2"
        >
          <p className="text-gray-700 text-lg">Começa animado… e desiste no meio.</p>
          <p className="text-gray-900 font-bold text-xl">O problema não é você.</p>
          <p className="text-red-600 font-extrabold text-2xl">É o modelo errado.</p>
          <p className="text-gray-600 text-base mt-2">
            A maioria dos cursos ensina conteúdo. Mas não ensina você a evoluir.
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default PainSection
